/* ==========================================================================
   FROONZE LOYALTY CUSTOMIZATIONS - iHealth Labs
   1. Add the discount's product to the cart when a discount is applied
   2. Show the product name instead of the discount value in the wallet
   ========================================================================== */

/* ==========================================================================
   SCRIPT 1: Add product to cart on discount apply
   ========================================================================== */

window.frcpLastRedeemedProductId = null;
window.frcpApplyInFlight = false;

document.addEventListener("frcp.loyalty.mounted", function() {
  setTimeout(function() {

    var spendingRules = frcp.loyalty.settings.spending_rules;

    /* Collect target product IDs from product-scoped spending rules */
    var targetProductIds = [];
    for (var i = 0; i < spendingRules.length; i++) {
      var rule = spendingRules[i];
      if (
        rule.discount_apply_to === "products" &&
        rule.discount_product_ids &&
        rule.discount_product_ids.length === 1
      ) {
        var tpid = String(rule.discount_product_ids[0]);
        if (targetProductIds.indexOf(tpid) === -1) {
          targetProductIds.push(tpid);
        }
      }
    }

    if (targetProductIds.length === 0) return;

    /* Build productId -> variantId map from /products.json */
    function buildVariantMap(productIds, callback) {
      var map = {};
      var page = 1;
      var limit = 250;
      var maxPages = 20;

      function fetchPage() {
        fetch("/products.json?limit=" + limit + "&page=" + page)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.products || [];

            for (var i = 0; i < products.length; i++) {
              var p = products[i];
              var pid = String(p.id);
              if (productIds.indexOf(pid) === -1) continue;
              if (!p.variants || p.variants.length === 0) continue;

              /* Prefer an available variant over a sold-out first variant */
              var chosen = null;
              for (var v = 0; v < p.variants.length; v++) {
                if (p.variants[v].available) { chosen = p.variants[v]; break; }
              }
              if (!chosen) chosen = p.variants[0];

              map[pid] = chosen.id;
            }

            var foundAll = Object.keys(map).length === productIds.length;

            if (foundAll || products.length < limit || page >= maxPages) {
              callback(map);
            } else {
              page++;
              fetchPage();
            }
          })
          .catch(function() { callback(map); });
      }

      fetchPage();
    }

    buildVariantMap(targetProductIds, function(variantMap) {

      /* ----------------------------------------------------------------
         APPLY LOCK

         Only one apply operation may be in flight at a time. This prevents
         two problems:
           1. Concurrent /cart/add.js calls, which Shopify can drop silently
           2. Overlapping toast observers, which would otherwise both fire
              on whichever success toast appears first and add the wrong
              product

         This applies to the WALLET apply buttons only. The redeem modal's
         "Apply to cart" button is deliberately left alone: adding
         frcp-btn--disabled to it suppresses Froonze's own click handler,
         so the discount is never applied and the flow stalls.

         The wallet apply control is a span[role=button], so the disabled
         attribute does nothing. pointer-events:none is used instead, which
         blocks the click before it reaches any listener including Froonze's,
         so the discount itself is not applied either.
         ---------------------------------------------------------------- */

      function setApplyButtonsDisabled(disabled) {
        var btns = document.querySelectorAll(".frcp-loyalty-wallet .frcp-loyalty-discount__main-btn");
        for (var i = 0; i < btns.length; i++) {
          var b = btns[i];
          if (disabled) {
            b.classList.add("frcp-btn--disabled");
            b.style.pointerEvents = "none";
            b.style.opacity = "0.5";
            b.style.cursor = "default";
            b.setAttribute("aria-disabled", "true");
            b.setAttribute("tabindex", "-1");
          } else {
            b.classList.remove("frcp-btn--disabled");
            b.style.pointerEvents = "";
            b.style.opacity = "";
            b.style.cursor = "";
            b.removeAttribute("aria-disabled");
            b.setAttribute("tabindex", "0");
          }
        }
      }

      function acquireLock() {
        if (window.frcpApplyInFlight) return false;
        window.frcpApplyInFlight = true;
        setApplyButtonsDisabled(true);
        return true;
      }

      function releaseLock() {
        window.frcpApplyInFlight = false;
        setApplyButtonsDisabled(false);
      }

      /* Cart helpers.
         showCartPopUp() is deliberately NOT called: customBundleScript.js
         is not loaded on this store, and the Qikify Slide Cart app embed
         handles drawer feedback on /cart/add.js automatically. */
      function updateCartCount() {
        return fetch("/cart.js")
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEl = document.querySelector("#CartCount span[data-cart-count]");
            var bubbleEl = document.querySelector("#CartCount");
            if (bubbleEl && cart.item_count > 0) bubbleEl.classList.remove("hide");
            if (countEl) countEl.innerHTML = cart.item_count;
          })
          .catch(function() {});
      }

      /* Adds the product, then releases the lock (if held) once the cart settles */
      function addProductToCart(variantId, useLock) {
        function finish() { if (useLock) releaseLock(); }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function(r) {
          if (!r.ok) return null;
          return r.json();
        })
        .then(function(response) {
          if (!response) { finish(); return; }
          return updateCartCount().then(function() { finish(); });
        })
        .catch(function() { finish(); });
      }

      /* ----------------------------------------------------------------
         Toast detection

         Waits for a newly inserted Froonze toast. Checking addedNodes
         rather than querying the document avoids matching a stale toast
         still on screen from a previous action.

         A success toast proceeds to the cart add. Any other Froonze toast
         (e.g. a discount that cannot be combined) releases the lock early
         instead of waiting out the timeout.
         ---------------------------------------------------------------- */

      function findToast(node) {
        if (!node || node.nodeType !== 1) return null;
        if (node.classList && node.classList.contains("frcp-swal-toast--success")) return "success";
        if (node.className && String(node.className).indexOf("frcp-swal-toast") !== -1) return "other";
        if (node.querySelector) {
          if (node.querySelector(".frcp-swal-toast--success")) return "success";
          if (node.querySelector("[class*='frcp-swal-toast']")) return "other";
        }
        return null;
      }

      function waitForSuccessToastThenAddProduct(variantId, useLock) {
        var done = false;

        var observer = new MutationObserver(function(mutations, obs) {
          if (done) return;
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var n = 0; n < added.length; n++) {
              var kind = findToast(added[n]);
              if (!kind) continue;

              done = true;
              obs.disconnect();

              if (kind === "success") {
                addProductToCart(variantId, useLock);
              } else {
                /* Discount was not applied - do not add the product */
                if (useLock) releaseLock();
              }
              return;
            }
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        setTimeout(function() {
          if (done) return;
          done = true;
          observer.disconnect();
          if (useLock) releaseLock();
        }, 8000);
      }

      /* ----------------------------------------------------------------
         REDEEM FLOW

         Step 1 modal: swal2-title = the spending rule title
                       html-container = "Redeem 300 points for a $30.00 coupon"
         Step 2 modal: swal2-title = "Successfully redeemed discount"
                       confirm button = "Apply to cart"

         The product ID is captured from the step-1 modal title (with points
         cost as a tiebreaker), so no redeem-card DOM matching is needed.
         The confirm button is reused between steps, so the click handler is
         delegated rather than bound to the element.
         ---------------------------------------------------------------- */

      function findRuleByTitle(title, bodyText) {
        var matches = [];
        for (var i = 0; i < spendingRules.length; i++) {
          if (spendingRules[i].title === title) matches.push(spendingRules[i]);
        }

        if (matches.length === 0) return null;
        if (matches.length === 1) return matches[0];

        for (var m = 0; m < matches.length; m++) {
          var costStr = String(matches[m].points_cost);
          if (bodyText && bodyText.indexOf(costStr) !== -1) return matches[m];
        }
        return matches[0];
      }

      var seenTitle = null;
      var modalObserver = new MutationObserver(function() {
        var popup = document.querySelector(".swal2-popup.frcp-swall__popup");
        if (!popup) { seenTitle = null; return; }

        var titleEl = popup.querySelector(".swal2-title");
        if (!titleEl) return;

        var titleText = titleEl.textContent.trim();
        if (seenTitle === titleText) return;
        seenTitle = titleText;

        var bodyEl = popup.querySelector(".swal2-html-container");
        var bodyText = bodyEl ? bodyEl.textContent.trim() : "";

        var rule = findRuleByTitle(titleText, bodyText);
        if (!rule) return;

        if (
          rule.discount_apply_to === "products" &&
          rule.discount_product_ids &&
          rule.discount_product_ids.length === 1
        ) {
          window.frcpLastRedeemedProductId = String(rule.discount_product_ids[0]);
        } else {
          window.frcpLastRedeemedProductId = null;
        }
      });
      modalObserver.observe(document.body, { childList: true, subtree: true });

      document.addEventListener("click", function(e) {
        var btn = e.target && e.target.closest ? e.target.closest(".swal2-confirm") : null;
        if (!btn) return;
        if (btn.textContent.trim() !== "Apply to cart") return;

        var pid = window.frcpLastRedeemedProductId;
        if (!pid) return;

        var variantId = variantMap[pid];
        if (!variantId) {
          window.frcpLastRedeemedProductId = null;
          return;
        }

        /* No lock here: the redeem modal flow is inherently serial, and
           touching this button interferes with Froonze's own handler. */
        waitForSuccessToastThenAddProduct(variantId, false);
        window.frcpLastRedeemedProductId = null;
      }, true);

      /* ----------------------------------------------------------------
         WALLET FLOW
         Matched by discount code (not DOM index) so pagination is safe.
         ---------------------------------------------------------------- */

      /* Strip a leading "Code:" prefix without using a regex */
      function stripCodePrefix(text) {
        var t = text.trim();
        var lower = t.toLowerCase();
        if (lower.indexOf("code:") === 0) {
          t = t.substring(5);
        }
        return t.trim();
      }

      function buildCodeToProductMap() {
        var map = {};
        var discounts = frcp.loyalty.customer.data.discounts || [];
        for (var i = 0; i < discounts.length; i++) {
          var d = discounts[i];
          if (d.code && d.productIds && d.productIds.length === 1) {
            map[d.code] = String(d.productIds[0]);
          }
        }
        return map;
      }

      function hookWalletCards() {
        var codeMap = buildCodeToProductMap();
        var cards = document.querySelectorAll(".frcp-loyalty-wallet .frcp-loyalty-discount");

        for (var j = 0; j < cards.length; j++) {
          (function(card) {
            if (card.getAttribute("data-cart-hooked")) return;

            var codeEl = card.querySelector(".frcp-loyalty-discount__code");
            if (!codeEl) return;

            var code = stripCodePrefix(codeEl.textContent);
            var pid = codeMap[code];
            if (!pid) return;

            var variantId = variantMap[pid];
            if (!variantId) return;

            var applyBtn = card.querySelector(".frcp-loyalty-discount__main-btn");
            if (!applyBtn) return;

            applyBtn.addEventListener("click", function() {
              /* Guard in addition to pointer-events, for keyboard activation */
              if (window.frcpApplyInFlight) return;
              if (!acquireLock()) return;
              waitForSuccessToastThenAddProduct(variantId, true);
            });

            /* Only mark hooked once the listener is actually attached */
            card.setAttribute("data-cart-hooked", "1");

          })(cards[j]);
        }

        /* Newly rendered cards must inherit the current lock state */
        if (window.frcpApplyInFlight) setApplyButtonsDisabled(true);
      }

      hookWalletCards();

      var rewardsContent = document.querySelector(".frcp-loyalty-wallet__rewards-content");
      if (rewardsContent) {
        var walletObserver = new MutationObserver(function() { hookWalletCards(); });
        walletObserver.observe(rewardsContent, { childList: true, subtree: true });
      }

    }); /* end buildVariantMap callback */

  }, 1000);
});

/* ==========================================================================
   SCRIPT 2: Wallet card customisations
   - Show the spending rule title instead of the generic discount value
   - Restore the spending rule custom icon when Froonze has not populated it

   A newly redeemed discount arrives in frcp.loyalty.customer.data.discounts
   without an iconUrl key until the page is reloaded, so Froonze renders its
   generic fallback icon. Both cases are resolved the same way: map the card
   to its discount by code, then to its spending rule by product ID.
   ========================================================================== */

document.addEventListener("frcp.loyalty.mounted", function() {
  setTimeout(function() {

    var spendingRules = frcp.loyalty.settings.spending_rules;

    /* productId -> custom title, and productId -> custom icon URL */
    var productTitleMap = {};
    var productIconMap = {};

    for (var i = 0; i < spendingRules.length; i++) {
      var rule = spendingRules[i];
      if (
        rule.discount_apply_to !== "products" ||
        !rule.discount_product_ids ||
        rule.discount_product_ids.length !== 1
      ) continue;

      var rpid = String(rule.discount_product_ids[0]);

      if (rule.use_a_custom_title && rule.title) {
        productTitleMap[rpid] = rule.title;
      }
      if (rule.custom_icon_url) {
        productIconMap[rpid] = rule.custom_icon_url;
      }
    }

    /* Strip a leading "Code:" prefix without using a regex */
    function stripCodePrefix(text) {
      var t = text.trim();
      var lower = t.toLowerCase();
      if (lower.indexOf("code:") === 0) {
        t = t.substring(5);
      }
      return t.trim();
    }

    function buildCodeMap() {
      var map = {};
      var discounts = frcp.loyalty.customer.data.discounts || [];
      for (var i = 0; i < discounts.length; i++) {
        var d = discounts[i];
        if (d.code && d.productIds && d.productIds.length === 1) {
          map[d.code] = String(d.productIds[0]);
        }
      }
      return map;
    }

    /* Replace Froonze's generic fallback icon with the spending rule icon.
       Mirrors the markup Froonze itself renders when iconUrl is present. */
    function injectIcon(card, iconUrl) {
      var iconEl = card.querySelector(".frcp-loyalty-discount__icon");
      if (!iconEl) return false;

      /* Already a real custom icon - leave it alone */
      if (iconEl.tagName === "IMG") return true;
      if (!iconEl.parentNode) return false;

      var img = document.createElement("img");
      img.setAttribute("src", iconUrl);
      img.setAttribute("class", "frcp-loyalty-discount__icon frcp-spending-rule__custom-icon");
      img.setAttribute("role", "presentation");
      img.setAttribute("alt", "");

      iconEl.parentNode.replaceChild(img, iconEl);
      return true;
    }

    function injectWalletCustomisations() {
      var codeMap = buildCodeMap();
      var cards = document.querySelectorAll(".frcp-loyalty-wallet .frcp-loyalty-discount");

      for (var j = 0; j < cards.length; j++) {
        (function(card) {

          var needsTitle = !card.getAttribute("data-title-injected");
          var needsIcon = !card.getAttribute("data-icon-injected");
          if (!needsTitle && !needsIcon) return;

          var codeEl = card.querySelector(".frcp-loyalty-discount__code");
          if (!codeEl) return;

          var code = stripCodePrefix(codeEl.textContent);
          var productId = codeMap[code];
          if (!productId) return;

          /* Title */
          if (needsTitle) {
            var customTitle = productTitleMap[productId];
            if (customTitle) {
              var titleEl = card.querySelector(".frcp-loyalty-discount__title");
              if (titleEl) {
                titleEl.textContent = customTitle;
                card.setAttribute("data-title-injected", "1");
              }
            }
          }

          /* Icon */
          if (needsIcon) {
            var iconUrl = productIconMap[productId];
            if (iconUrl) {
              if (injectIcon(card, iconUrl)) {
                card.setAttribute("data-icon-injected", "1");
              }
            }
          }

        })(cards[j]);
      }
    }

    injectWalletCustomisations();

    var rewardsContent = document.querySelector(".frcp-loyalty-wallet__rewards-content");
    if (rewardsContent) {
      var walletObserver = new MutationObserver(function() { injectWalletCustomisations(); });
      walletObserver.observe(rewardsContent, { childList: true, subtree: true });
    }

  }, 1000);
});